package com.rikonardo.pluginscan.framework.types

class ScanResult(val reports: List<CheckReport>, val errors: List<ScanError>)